import { render, staticRenderFns } from "./TenderList.vue?vue&type=template&id=53f6c89c&scoped=true"
import script from "./TenderList.vue?vue&type=script&lang=js"
export * from "./TenderList.vue?vue&type=script&lang=js"
import style0 from "./TenderList.vue?vue&type=style&index=0&id=53f6c89c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f6c89c",
  null
  
)

export default component.exports